<template>
    <div>
        <vs-card title="Foreground Pick" class="p-4 mb-6">
            <div slot="header" class="flex flex-wrap items-center justify-between">
                <div class="flex items-center">
                    <vs-button radius color="primary" icon="keyboard_backspace" @click="back"></vs-button>
                    <h4 style="margin-left: 10px">Foreground Pick</h4>
                </div>
                <div class="flex items-center">
                    <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" @click="submitForm">Save</vs-button>
                </div>
            </div>
            <div class="vx-row mt-6">
                <div class="vx-col md:w-1/2 w-full">
                    <div class="vx-row mb-3">
                        <div class="vx-col w-full">
                            <vs-input class="w-full" label="Stock Transfer Reference *" v-model="header.reference" disabled/>
                        </div>
                    </div>
                    <div class="vx-row mb-3 mt-1">
                        <div class="vx-col w-full">
                            <label for="" class="vs-input--label">Movement Date *</label>
                            <flat-pickr class="w-full" v-model="movement_date"/>
                        </div>
                    </div>
                </div>
            </div>
        </vs-card>
        <vs-card title="Item Details" class="p-4 mb-6">
            <vs-table multiple v-model="selected" :data="pick" stripe>
                <template slot="thead">
                    <vs-th>Line ID</vs-th>
                    <vs-th>Product ID</vs-th>
                    <vs-th>Description</vs-th>
                    <vs-th>Pack ID</vs-th>
                    <vs-th>Batch</vs-th>
                    <vs-th>Exp. Date</vs-th>
                    <vs-th>Qty</vs-th>
                    <vs-th>UoM</vs-th>
                    <vs-th>Stock Type</vs-th>
                    <vs-th>Location Type</vs-th>
                    <vs-th>Location ID</vs-th>
                    <vs-th>Storage Unit</vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                    <vs-td :data="data[indextr].line_id">
                        {{ indextr + 1 }}
                    </vs-td>

                    <vs-td :data="data[indextr].line_id">
                        {{ data[indextr].product_code }}
                    </vs-td>

                    <vs-td :data="data[indextr].line_id">
                        {{ data[indextr].description_1 }}
                    </vs-td>

                    <vs-td :data="data[indextr].line_id">
                        {{ data[indextr].pack_id }}
                    </vs-td>

                    <vs-td :data="data[indextr].line_id">
                        {{ data[indextr].batch }}
                    </vs-td>

                    <vs-td :data="data[indextr].line_id">
                        {{ data[indextr].expired_date }}
                    </vs-td>
                    
                    <vs-td :data="data[indextr].line_id">
                        {{ data[indextr].base_qty}}
                    </vs-td>

                    <vs-td :data="data[indextr].line_id">
                        {{ data[indextr].base_uom_name }}
                    </vs-td>

                    <vs-td :data="data[indextr].line_id">
                        {{ data[indextr].stock_type_name }}
                    </vs-td>

                    <vs-td :data="data[indextr].line_id">
                        {{ data[indextr].location_code }}
                    </vs-td>

                    <vs-td :data="data[indextr].line_id">
                        {{ data[indextr].location_code }}
                    </vs-td>

                    <vs-td :data="data[indextr].line_id">
                        {{ data[indextr].storage_unit }}
                    </vs-td>

                    </vs-tr>
                </template>
            </vs-table>
        </vs-card>
        <vs-popup
            :active.sync="pickModal"
            title="Item Detail"
            fullscreen
            v-if="modalData.length != 0"
        >
            <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full">
                    <div class="vx-row mb-3">
                        <div class="vx-col w-full">
                            <vs-input class="w-full" label="Stock Transfer Line ID" v-model="modalData[0].draft_line_id" disabled/>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-full">
                            <vs-input class="w-full" label="Product ID" v-model="modalData[0].product_code" disabled/>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-full">
                            <vs-input class="w-full" label="Description" v-model="modalData[0].description_1" disabled/>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-full">
                            <vs-input class="w-full" v-model="modalData[0].description_2" disabled/>
                        </div>
                    </div>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                    <div class="vx-row mb-3">
                        <div class="vx-col w-full">
                            <vs-input class="w-full" label="Stock Type" v-model="modalData[0].stock_type_name" disabled/>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col md:w-1/2">
                            <vs-input class="w-full" label="Base Qty" :value="modalData[0].total_item" disabled/>
                        </div>
                        <div class="vx-col md:w-1/2">
                            <vs-input class="w-full" label=" " v-model="modalData[0].base_uom_name" disabled/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="vx-row mt-10" style="padding-left: 10px; padding-right: 10px">
                <vs-card title="Item Details" class="p-4 mb-6">
                    <div slot="header" class="flex flex-wrap items-center justify-between">
                        <div class="flex items-center">
                            <vs-button color="danger" class="btn mb-4 md:mb-0 mr-1" @click="deleteData">Delete</vs-button>
                            <!-- <vs-button color="danger" class="btn mb-4 md:mb-0 mr-1" @click="addData">Add</vs-button> -->
                        </div>
                        <div class="flex items-center">
                            <vs-button color="warning" class="btn mb-4 md:mb-0 mr-1" @click="skipData">Skip</vs-button>
                            <vs-button color="success" class="btn mb-4 md:mb-0 mr-1" @click="saveData">Save</vs-button>
                        </div>
                    </div>
                    <div style="overflow-x: auto">
                        <vs-table multiple v-model="modalSelected" :data="modalData" stripe>
                            <template slot="thead">
                                <vs-th>Line ID</vs-th>
                                <vs-th>Pack ID</vs-th>
                                <vs-th>Batch</vs-th>
                                <vs-th>Exp. Date</vs-th>
                                <vs-th style="width: 10%">Qty</vs-th>
                                <vs-th>UoM</vs-th>
                                <vs-th>Location ID</vs-th>
                                <vs-th>Storage Unit</vs-th>
                            </template>

                            <template slot-scope="{data}">
                                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" v-show="tr.data_status != 'delete'">

                                    <vs-td :data="tr.line_id">
                                        {{ tr.draft_line_id }}
                                    </vs-td>

                                    <vs-td :data="tr.line_id">
                                        {{ tr.pack_id ? tr.pack_id : '' }}
                                    </vs-td>

                                    <vs-td :data="tr.line_id">
                                        {{ tr.batch ? tr.batch : '' }}
                                    </vs-td>

                                    <vs-td :data="tr.line_id">
                                        {{ tr.expired_date ? tr.expired_date : '' }}
                                    </vs-td>

                                    <vs-td :data="tr.line_id">
                                        <vs-input class="w-full" v-model="tr.base_qty"/>
                                    </vs-td>

                                    <vs-td :data="tr.line_id">
                                        {{ tr.base_uom_name }}                                    
                                    </vs-td>
                                    
                                    <vs-td :data="tr.line_id">
                                        <vs-select
                                            class="selectExample"
                                            v-model="tr.inventory_first_id"
                                            width="100%"
                                            autocomplete
                                            @input="changeLocation(tr)"
                                        >
                                            <vs-select-item v-for="(item, index) in locationOption" :key="index" :value="item.value" :text="item.text"/>
                                        </vs-select>
                                    </vs-td>

                                    <vs-td :data="tr.line_id">
                                        {{ tr.storage_unit }}
                                    </vs-td>

                                </vs-tr>
                            </template>
                        </vs-table>
                    </div>
                </vs-card>
            </div>
        </vs-popup>
    </div>  
</template>

<script>
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import vSelect from 'vue-select'

export default {
    components:{
        flatPickr,
        vSelect
    },
    data() {
        return {
            selected: [],
            pick: [],
            drafts: [],
            do_reference: '',
            movement_date: new Date(),
            currentIndex: 0,
            pickModal: false,
            modalData: [],
            pickAssignError: '',
            locationOption: [],
            modalSelected: [],
            isLoading: false,
            header: {}
        }
    },
    watch: {
        isLoading: function(){
            if(this.isLoading){
                this.$vs.loading()
            }
            else{
                this.$vs.loading.close()
            }
        }
    },
    methods: {
        fetchData() {
            const data = this.$route.params.data
            data.map(item => {
                item.data_status = 'submit'
            })

            let groupBy = key => array =>
            array.reduce((objectsByKeyValue, obj) => {
                const value = obj[key];
                objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
                return objectsByKeyValue;
            }, {})

            let groupById = groupBy('draft_detail_id')
            let partitionData = groupById(data)

            Object.values(partitionData).map(item => {
                this.drafts.push(item)
            })

            this.drafts.map(item => {
                let totalItem = 0

                item.map(value => {
                    totalItem += value.base_qty
                })

                item.map(value => {
                    value.total_item = totalItem
                })
            })
            
            this.showModal(this.currentIndex)
        },
        back() {
            this.$vs.dialog({
                color: 'warning',
                title: 'Leave Page',
                text: 'Changes you made may not be saved?',
                acceptText: 'Leave Page',
                accept: () => this.$router.push({ name: 'stock-transfer-view', params: {id: this.$route.params.id} }),
            })
        },
        submitForm() {
            let error = false
            const moHead = {
                stock_transfer_id: this.$route.params.id,
                movement_date: this.movement_date,
                type: 'PICK'
            }

            const details = []

            if(this.selected.length <= 0) {
                this.$vs.notify({
                    color: 'danger',
                    title: 'Error',
                    iconPack: 'feather',
                    icon:'icon-x',
                    text: 'No item selected'
                })
                return false
            }

            this.selected.map(item => {
                if(!item.inventory_first_id) {
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: 'No location assigned.'
                    })

                    error = true
                }
                else {
                    details.push(item.draft_id)
                }
            })

            if(error) {
                return false
            }
            else {
                this.isLoading = true
                const dataSend = {
                    movement_order: JSON.stringify(moHead),
                    movement_order_details: JSON.stringify(details)
                }

                this.$http.post('inventories/stocktransfer/pickstocktransfer', dataSend)
                .then(() => {
                    this.isLoading = false ;
                    this.$vs.notify({
                        color: 'success',
                        title: 'Success',
                        iconPack: 'feather',
                        icon:'icon-check',
                        text: 'Saved successfully'
                    })
                    this.$router.push({ name: 'stock-transfer-view', params: {id: this.$route.params.id} })
                })
                .catch(error => this.handleError(error))
            }
        },
        showModal(index) {
            if(!this.drafts[index]) {
                return false
            }
            else {
                const data = {
                    stock_transfer_id: this.drafts[index][0].draft_id,
                    detail_id: this.drafts[index][0].draft_detail_id
                }
                
                let lineId = 1
                this.modalData = []
                this.isLoading = true

                this.$http.post('pick/searchstockinventories', data)
                .then(res => {
                    this.locationOption = []
                    this.isLoading = false
                    this.pickModal = true
                    this.drafts[index].map(data => {
                        this.modalData.push(data)
                    })

                    this.modalData.map(item => {
                        item.draft_line_id = lineId
                        lineId++
                    })

                    res.data.map(item => {
                        this.locationOption.push({
                            value: item.id,
                            text: item.location.location_code + ` (Qty: ${item.base_qty - item.pick_qty})`,
                            storage_unit: item.storage_unit,
                            pack_id: item.pack_id,
                            batch: item.batch,
                            expired_date: item.expired_date,
                            location_code: item.location.location_code,
                            location_type: item.location.locations_type.code,
                            location_id: item.location.id
                        })
                    })
                })
                .catch((error) => {
                    this.isLoading = false
                    console.log(error)
                })
            }
        },
        skipData() {
            this.pickModal = false
            this.currentIndex++

            this.showModal(this.currentIndex)
        },
        saveData() {
            let deletedCount = 0
            const lineData = []
            let error = false
            const expectedQty = this.modalData[0].total_item
            let currentQty = 0

            this.modalData.map(item => {
                if(item.data_status == 'delete') {
                    deletedCount++
                }
            })

            if(deletedCount >= this.modalData.length) {
                this.$vs.notify({
                    color: 'danger',
                    title: 'Error',
                    iconPack: 'feather',
                    icon:'icon-x',
                    text: 'Detail is empty'
                })
                return false
            }

            for(let i = 0; i < this.modalData.length; i++) {
                if(!this.modalData[i].inventory_first_id && this.modalData[i].data_status == 'submit') {
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: 'No location ID assigned. Line ' + this.modalData[i].draft_line_id
                    })
                    error = true
                }
                else {
                    lineData.push({
                        inventory_id: this.modalData[i].inventory_first_id,
                        qty: this.modalData[i].base_qty,
                        draft_id: this.modalData[i].draft_id,
                        value: this.modalData[i].data_status,
                        line_id: this.modalData[i].draft_line_id
                    })
                }
            }

            this.modalData.map(item => {
                currentQty += parseInt(item.base_qty)
            })

            if(currentQty > expectedQty) {
                this.$vs.notify({
                    color: 'danger',
                    title: 'Error',
                    iconPack: 'feather',
                    icon:'icon-x',
                    text: 'Item quantity exceed. Base qty: ' + expectedQty + ' - Assigned qty: ' + currentQty
                })
                error = true
            }

            if(error) {
                return false
            }

            this.isLoading = true
            this.$http.post('pick/pickassignvalidation', {data: lineData, draft_detail_id: this.modalData[0].draft_detail_id, draft_id: this.modalData[0].draft_id})
            .then(res => {
                this.isLoading = false
                this.modalData.map(item => {
                    this.pick.push(item)
                    this.selected.push(item)
                })
                this.skipData()
            })
            .catch(error => {
                const message = error.response.data.message ? error.response.data.message : 'Something went wrong'

                this.isLoading = false
                this.$vs.notify({
                    color: 'danger',
                    title: 'Error',
                    iconPack: 'feather',
                    icon:'icon-x',
                    text: message
                })
            })
        },
        deleteData() {
            if(this.modalSelected.length == this.modalData.length) {
                this.$vs.notify({   
                    color: 'danger',
                    title: 'Error',
                    iconPack: 'feather',
                    icon: 'icon-x',
                    text: `Can't delete all data`
                })
            }
            else {
                this.modalSelected.map(item => {
                    this.modalData.map((data, index) => {
                        if(item.draft_line_id == data.draft_line_id) {
                            this.modalData.splice(index, 1)
                        }
                    })
                })

                this.modalSelected = []
                this.assignLineId()
            }
        },
        addData() {
            let maxQty = parseInt(this.modalData[0].total_item)
            let totalQty = 0

            this.modalData.map(data => {
                totalQty += parseInt(data.base_qty)
            })
            
            let remainingQty = maxQty - totalQty
            if(remainingQty > 0) {
                const copy = JSON.parse(JSON.stringify(this.modalData[0]))
                copy.base_qty = remainingQty
                copy.storage_unit = null
                copy.inventory = null
                copy.inventory_first_id = null
                copy.location_id = null
                this.modalData.push(copy)

                this.assignLineId()
            }
        },
        assignLineId() {
            let lineNumber = 1

            this.modalData.map(data => {
                data.draft_line_id = lineNumber
                lineNumber++
            })
        },
        changeLocation(tr) {
            this.locationOption.map(item => {
                if(tr.inventory_first_id == item.value) {
                    console.log(item)
                    tr.storage_unit = item.storage_unit
                    tr.pack_id = item.pack_id
                    tr.batch = item.batch
                    tr.expired_date = item.expired_date
                    tr.location_type_code = item.location_type
                    tr.location_code = item.location_code
                    tr.location_id = item.location_id
                }
            })
        }
    },
    mounted() {
        this.fetchData()
        this.header = this.$route.params.header
    }
}
</script>